import * as React from 'react';
import { SeatSelection } from '../../../../../Icons';
import Service from '../Service';
import { ServiceType } from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/types';
import { useServicePageProps } from '../../../../../CheckoutAdditionalService/components/hooks';
import ServiceCardDialog from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/components/ServiceCardDialog/ServiceCardDialog';
import ServicePage from '../../../../../Checkout/components/Checkout/ServicePage/ServicePage';
import { useTranslation } from 'react-i18next';
const Seat = services => {
    const seats = [];
    services.services.selectedServices.forEach(service => {
        seats.push(service.service.number);
    });
    const servicePageProps = useServicePageProps();
    const open = () => servicePageProps.toggleModal(ServiceType.Seats);
    const { t } = useTranslation('FlightInfoCard');
    return (React.createElement(React.Fragment, null,
        React.createElement(Service, { icon: SeatSelection, selected: seats.length > 0, onClick: open }, seats.length > 0 ? (React.createElement("span", null,
            t('Seats'),
            ": ",
            seats.join(','))) : (React.createElement("span", null, t('Choose comfortable seats')))),
        React.createElement(ServicePage, null, childrenProps => (React.createElement(ServiceCardDialog, Object.assign({ order: servicePageProps.order, openedModal: servicePageProps.openedModal, onClose: servicePageProps.toggleModal.bind(null, null), passengers: servicePageProps.passengers, passengerLabels: servicePageProps.passengerLabels }, childrenProps))))));
};
export default Seat;
